import React, { useEffect } from 'react';
import { Button, Text } from '@bufferapp/ui';
import { blue } from '@bufferapp/ui/style/colors';
import CheckmarkIcon from '@bufferapp/ui/Icon/Icons/Checkmark';
import translations from '~/i18n/translations/en-us.json';
import PropTypes from 'prop-types';
import { SEGMENT_NAMES } from '~/constants';
import { BufferTracker } from '@bufferapp/buffer-tracking-browser-ts';
import { useAccount } from '~/accountContext';
import UpgradePath from '../../upgrade-paths';
import {
  PaywallImage,
  PaywallWrapper,
  PaywallContent,
  PlusText,
} from './styles';

const contentStyle = {
  margin: '0 0 5px',
};

const listStyle = {
  listStyleType: 'none',
  padding: '2px',
  margin: '0 0 10px',
};

const BulletPoint = (props) => {
  const { text } = props;

  return (
    <li>
      {' '}
      <CheckmarkIcon size="medium" color={blue} /> <Text>{text}</Text>
    </li>
  );
};

BulletPoint.propTypes = {
  text: PropTypes.string.isRequired,
};

const ComposerHashtagPaywall = () => {
  const { account } = useAccount();
  const paywallTexts = translations['hashtag-manager-paywall'];
  const commonTrackingProps =
    account?.currentOrganization?.commonTrackingProperties || null;

  useEffect(() => {
    BufferTracker.ctaViewed({
      organizationId: account?.currentOrganization?.id || null,
      ctaName: `publish-hashtagManager-composer-seeUpgradeOptions`,
      upgradePathName: 'hashTag-composer-upgrade',
      product: 'publish',
      ...commonTrackingProps,
    });
  }, [account, commonTrackingProps]);

  return (
    <PaywallWrapper>
      <PaywallImage src="https://buffer-publish.s3.amazonaws.com/images/hashtag-manager-paywall-2.png" />
      <PaywallContent>
        <Text type="h3" style={contentStyle} data-testid="title">
          {paywallTexts.title}
        </Text>
        <PlusText>
          {paywallTexts.plus}
          ...
        </PlusText>
        <ul style={listStyle}>
          {paywallTexts.features.map((text, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <BulletPoint text={text} key={index} />
          ))}
        </ul>
        <UpgradePath>
          {(onUpgradeClick) => (
            <Button
              type="primary"
              label={paywallTexts.buttonText}
              onClick={() => {
                BufferTracker.ctaClicked({
                  organizationId: account?.currentOrganization?.id || '',
                  ctaName: `publish-hashtagManager-composer-seeUpgradeOptions`,
                  cta: `publish-hashtagManager-composer-seeUpgradeOptions`,
                  upgradePathName: 'hashTag-composer-upgrade',
                  product: 'publish',
                  clientName: 'publishWeb',
                  ...commonTrackingProps,
                });

                onUpgradeClick({
                  cta: SEGMENT_NAMES.HASHTAG_MANAGER_UPGRADE,
                  ctaMPMigration:
                    SEGMENT_NAMES.HASHTAG_MANAGER_UPGRADE_TO_MIGRATION_HUB,
                });
              }}
              fullWidth
            />
          )}
        </UpgradePath>
      </PaywallContent>
    </PaywallWrapper>
  );
};

ComposerHashtagPaywall.propTypes = {};

export default ComposerHashtagPaywall;
